<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-3"><a id="_idTextAnchor003"></a>Angel Prayer 1</h2>
<p class="Verse-new">Stay by me </p>
<p class="Verse-main">angel</p>
<p class="Verse-main">uphold me</p>
<p class="Verse-main">that my feet</p>
<p class="Verse-main">don’t slip.</p>
<p class="Verse-new">Teach me</p>
<p class="Verse-main">to hymn the Holy</p>
<p class="Verse-main">with resounding alleluias</p>
<p class="Verse-main">from the heart</p>
<p class="Verse-main">heavenly </p>
<p class="Verse-main">as the angel-voices</p>
<p class="Verse-main">all around me </p>
<p class="Verse-main">that I hear.</p>
<p class="Note">Prayer attributed to Johann Sebastian Bach</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-5.vue?af2f03c0